var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 8.33333C10.5033 8.33333 9.70333 8.2 8.95333 7.95333C8.72333 7.88 8.46 7.93333 8.27667 8.11667L6.81 9.58667C4.92 8.62667 3.38 7.08333 2.41667 5.19667L3.88333 3.72667C4.06667 3.54333 4.12 3.28 4.04667 3.05C3.8 2.3 3.66667 1.49667 3.66667 0.666667C3.66667 0.296667 3.37 0 3 0H0.666667C0.296667 0 0 0.296667 0 0.666667C0 6.92667 5.07333 12 11.3333 12C11.7033 12 12 11.7033 12 11.3333V9C12 8.63 11.7033 8.33333 11.3333 8.33333Z",
    fill: "#2760A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.aebb7c1e9a683c28e92fa386c3a1f4e8.svg";
export { ForwardRef as ReactComponent };